export default __webpack_public_path__ + "static/media/Shoe-3.4d037fc8.webm";